// Login form for the user to sign in
import LoginView from "@/views/LoginView"

// Landing page for My Brokk
import StartView from "@/views/StartView"
import HomeView from "@/views/HomeView"

// Brokk Connect section
import TenantsView from "@/views/TenantsView"
import MapView from "@/views/MapView"
import MachinesView from "@/views/MachinesView"
import UsersView from "@/views/UsersView"
import ReportsView from "@/views/ReportsView"

// Fleet analytics section
import FleetAnalyticsDashboard from "@/views/fleetAnalytics/DashboardView"
import FleetAnalyticsMachines from "@/views/fleetAnalytics/MachinesView"

//
// Documents section
//

// Documents root view
import DocumentsView from "@/views/documents/DocumentsView"
import DocumentsManualsSelectionView from "@/views/documents/DocumentsManualsSelectionView"
import DocumentsManualsView from "@/views/documents/DocumentsManualsView"

import SparePartsSearchTool from "@/views/documents/SparePartsSearchTool"

import DownloadsView from "@/views/downloads/DownloadsView"

// Auxiliary views
import TenantHome from "@/components/TenantHome"
import MachineView from "@/views/MachineView"

// Views showing details about one machine
import MachineAlarms from "@/views/machine/Alarms"
import MachineInfo from "@/views/machine/MachineInfo"
import MachineSystem from "@/views/machine/System"
import MachineDashboard from "@/views/machine/Dashboard"
import MachineMaintenance from "@/views/machine/Maintenance"
import MachineManuals from "@/views/machine/Manuals"
import MachineMeasurements from "@/views/machine/Measurements"
import MachineRental from "@/views/machine/Rental"
import MachineLocation from "@/views/machine/Location"
import MachineParameters from "@/views/machine/Parameters"
import MachineInspection from "@/views/machine/Inspection"

// Views related to a tenant
import TenantView from "@/views/TenantView"
import TenantProfile from "@/views/tenant/TenantProfile"
import TenantCustomer from "@/views/tenant/TenantCustomer"
import TenantContacts from "@/views/tenant/TenantContacts"

// Views related to users
import UserAccountView from "@/views/user/UserAccountView"
import UserProfile from "@/views/user/UserProfile"
import UserSettings from "@/views/user/UserSettings"

// Views related to onboarding users
import FirstLogin from "@/views/onboarding/FirstLogin"
import ForgotPassword from "@/views/onboarding/ForgotPassword"
import ResetPassword from "@/views/onboarding/ResetPassword"

import MessagesView from "@/views/MessagesView"

import HelpView from "@/views/HelpView"

import { store } from "../store"

export const routes = [
  {
    path: "/",
    component: StartView,
    redirect: "/home",
    name: "start",
    children: [
      {
        path: "/home",
        component: HomeView
      },
      {
        path: "/messages",
        component: MessagesView,
        name: "messages"
      },
      {
        path: "/user_account",
        component: UserAccountView,
        redirect: { name: "userAccountProfile" },
        children: [
          {
            path: "profile",
            component: UserProfile,
            name: "userAccountProfile"
          },
          {
            path: "settings",
            component: UserSettings,
            name: "userAccountSettings"
          }
        ]
      },
      // Machines
      {
        path: "/machines/:tenantUid/:serialNo",
        component: MachineView,
        props: true,
        children: [
          {
            path: "dashboard",
            component: MachineDashboard,
            props: true,
            name: "dashboard"
          },
          {
            path: "info",
            component: MachineInfo,
            props: true,
            name: "info"
          },
          {
            path: "alarms",
            component: MachineAlarms,
            props: true,
            name: "alarms"
          },
          {
            path: "measurements",
            component: MachineMeasurements,
            props: true,
            name: "measurements"
          },
          {
            path: "maintenance",
            component: MachineMaintenance,
            props: true,
            name: "maintenance"
          },
          {
            path: "rental",
            component: MachineRental,
            props: true,
            name: "rental"
          },
          {
            path: "location",
            component: MachineLocation,
            props: true,
            name: "location"
          },
          {
            path: "parameters",
            component: MachineParameters,
            props: true,
            name: "parameters"
          },
          {
            path: "system",
            component: MachineSystem,
            props: true,
            name: "system"
          },
          {
            path: "documents",
            component: MachineManuals,
            props: true,
            name: "machineDocuments"
          },
          {
            path: "inspection",
            component: MachineInspection,
            props: true,
            name: "machineInspection"
          }
        ]
      },
      // Tenants
      {
        path: "/tenants",
        component: TenantsView,
        name: "tenants",
        children: [
          {
            path: "/tenants/:tenantUid",
            component: TenantHome,
            children: [
              {
                path: "machines",
                component: MachinesView,
                props: true
              },
              {
                path: "map",
                component: MapView,
                props: true
              },
              {
                path: "users",
                component: UsersView,
                props: true
              },
              {
                path: "reports",
                component: ReportsView,
                props: true
              },
              {
                path: "fleet_analytics_dashboard",
                component: FleetAnalyticsDashboard,
                props: true
              },
              {
                path: "fleet_analytics_machines",
                component: FleetAnalyticsMachines,
                props: true
              }
            ]
          }
        ]
      },
      // Documents
      {
        path: "/documents",
        component: DocumentsView,
        props: true,
        redirect: { name: "documents_manuals" },
        children: [
          {
            path: "manuals",
            name: "documents_manuals",
            component: DocumentsManualsSelectionView,
            props: true,
            children: [
              {
                path: "view",
                component: DocumentsManualsView
              }
            ]
          },
          {
            path: "spare_parts",
            component: SparePartsSearchTool,
            props: true,
            name: "sparepartssearchtool"
          }
        ]
      },
      {
        path: "/tenant_details/:tenantUid",
        component: TenantView,
        redirect: { name: "tenantProfile" },
        props: true,
        children: [
          {
            path: "profile",
            component: TenantProfile,
            props: true,
            name: "tenantProfile"
          },
          {
            path: "customer",
            component: TenantCustomer,
            props: true,
            name: "tenantCustomer"
          },
          {
            path: "contacts",
            component: TenantContacts,
            props: true,
            name: "tenantContacts"
          }
        ]
      },
      {
        path: "downloads",
        component: DownloadsView,
        props: true
      }
    ]
  },
  {
    path: "/help",
    component: HelpView,
    props: true
  },
  {
    path: "/forgot_password",
    component: ForgotPassword,
    name: "forgotPassword"
  },
  {
    path: "/verify/:username/:code",
    component: FirstLogin,
    name: "verify"
  },
  {
    path: "/reset/:username/:code",
    component: ResetPassword,
    name: "reset"
  },
  {
    path: "/login",
    component: LoginView,
    name: "login"
  },
  {
    path: "/shop",
    redirect: () => {
      window.location = store.getters.webshopURL
    }
  },
  {
    path: "/servicePortal",
    redirect: () => {
      window.location = store.getters.serviceportalURL
    }
  },
  {
    path: "/crm",
    redirect: () => {
      window.location = store.getters.crmURL
    }
  },
  {
    path: "/test",
    redirect: () => {
      window.location = "https://testshop.dev.brk-dev-iot.net"
    }
  }
]
